import React from "react"
import handleViewport from "react-in-viewport"

import styled from "styled-components"
import { Grid } from "../../atoms/grid"
import CountUp from "react-countup"

import Crowd from "../../../images/icons/icons_1.png"
import Globe from "../../../images/icons/home_exhibitors.svg"
import Handshake from "../../../images/icons/icons_2.png"
import Globecrowd from "../../../images/icons/icons_4.png"
import Warship from "../../../images/icons/icons_3.png"
import Wheel from "../../../images/icons/icons_5.png"

import { Settings } from "../../../styles/theme"

const Three = styled.div`
  position: relative;
  padding-bottom: 5rem;
  h4 {
    color: ${Settings.primaryColor};
    font-weight: 700;
    font-size: 3rem;
    margin: 0;
    width: 100%;
    white-space: nowrap;
    @media screen and (max-width: ${Settings.sizeM}) {
      font-size: 2rem !important;
    }
  }
  > div {
    align-items: flex-start !important;
    > div {
      align-items: flex-start !important;
      width: 30%;
      .large {
        font-size: 4rem;
        margin-top: 0;
      }
      img {
        height: auto;
        width: 100%;
      }
    }
  }
  h5 {
    font-weight: 700;
    color: ${Settings.primaryColor};
    margin: 0;
    margin-bottom: 0.5rem;
  }
  p {
    margin: 0;
  }
  .pad {
    @media screen and (min-width: ${Settings.sizeM}) {
      margin-top: 1rem;
    }
  }
`

class StatisticBlock extends React.Component {
  render() {
    const { inViewport } = this.props
    return (
      <Three>
        <Grid unstack>
          <div style={{ flex: "0 0 33%" }}>
            <div style={{ padding: "0 1rem" }}>
              <img
                src={Crowd}
                style={{
                  width: "auto",
                  margin: "0 auto",
                  maxHeight: "10rem",
                }}
              />
              <h6 style={{ margin: "0 0", fontSize: "1.1rem", fontWeight: "bold", color: "#195998" }}>
                Close to
              </h6>
              <CountUp
                start={inViewport ? 1 : 0}
                end={30000}
                duration={2.75}
                separator=","
              >
                {({ countUpRef, start, reset }) => (
                  <div>
                    <h4 className="large" ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <h5 style={{ marginTop: "0", fontSize: "1.3rem" }}>
                Trade attendees
              </h5>
              <p>From 110 countries and regions</p>
              {/*<p>(12.3% increase over the last event)</p>*/}
            </div>
          </div>
          <div style={{ flex: "0 0 33%" }}>
            <div style={{ padding: "1rem" }}>
              <div>
                <Grid unstack columns={2}>
                  <div style={{ flex: "0 0 40%" }}>
                    <img src={Handshake} />
                  </div>
                  <div style={{ flex: "0 0 55%" }}>
                    <CountUp
                      start={inViewport ? 1 : 0}
                      end={930}
                      duration={2.75}
                      separator=","
                    >
                      {({ countUpRef, start, reset }) => (
                        <div>
                          <h4 ref={countUpRef} />
                        </div>
                      )}
                    </CountUp>
                  </div>
                </Grid>
                <p>Participating companies from 45 countries</p>
              </div>
              <div className="pad">
                <div>
                  <Grid unstack columns={2}>
                    <div style={{ flex: "0 0 40%" }}>
                      <img src={Globecrowd} />
                    </div>
                    <div style={{ flex: "0 0 55%" }}>
                      <CountUp
                        start={inViewport ? 1 : 0}
                        end={660}
                        duration={2.75}
                        separator=","
                      >
                        {({ countUpRef, start, reset }) => (
                          <div>
                            <h4 ref={countUpRef} />
                          </div>
                        )}
                      </CountUp>
                    </div>
                  </Grid>
                  <p>Accredited media from 249 media outlets</p>
                </div>
              </div>
            </div>
          </div>
          <div style={{ flex: "0 0 33%" }}>
            <div style={{ padding: "1rem" }}>
              <div>
                <Grid unstack columns={2}>
                  <div style={{ flex: "0 0 40%" }}>
                    <img src={Warship} />
                  </div>
                  <div style={{ flex: "0 0 55%" }}>
                    <CountUp
                      start={inViewport ? 1 : 0}
                      end={117}
                      duration={2.75}
                      separator=","
                    >
                      {({ countUpRef, start, reset }) => (
                        <div>
                          <h4 ref={countUpRef} />
                        </div>
                      )}
                    </CountUp>
                  </div>
                </Grid>
                <p>Delegations from 36 countries and regions</p>
              </div>
              <div className="pad">
                <Grid unstack columns={2}>
                  <div style={{ flex: "0 0 40%" }}>
                    <img src={Wheel} />
                  </div>
                  <div style={{ flex: "0 0 55%" }}>
                    <CountUp
                      start={inViewport ? 1 : 0}
                      end={871}
                      duration={2.75}
                      separator=","
                    >
                      {({ countUpRef, start, reset }) => (
                        <div>
                          <h4 ref={countUpRef} />
                        </div>
                      )}
                    </CountUp>
                  </div>
                </Grid>
                <p>Exhibitor-delegation meetings</p>
              </div>
            </div>
          </div>
        </Grid>
      </Three>
    )
  }
}

export const Statistics = handleViewport(StatisticBlock)
